import React from 'react'
type DetailsBlockProps = {
  title: string;
  image: string;
};
const DetailsBlock = ({ title, image }: DetailsBlockProps) => {
  return (
    <div className="details-block container">
      <div className="desc">
        <h3 className="heading">About</h3>
        <h2 className="heading-title">{title}</h2>
        <p>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ratione
          corrupti qui nesciunt, quam tenetur nulla ea magnam mollitia pariatur
          maiores sunt praesentium laborum sint neque voluptates debitis vitae
          commodi officiis. <br/><br/>
          laboriosam corporis ducimus quia repellat? Omnis distinctio eaque
          atque nulla laboriosam rerum accusantium eveniet
        </p>
      </div>
      <div className="image-container">
        <img className="image" src={image} alt="adventure" />
      </div>
    </div>
  );
}

export default DetailsBlock